/* eslint-disable camelcase */

export default {
	mytest: `Mina tester`,
	fullname: 'Fullständigt namn',
	myCandidates: `Mina Kandidater`,
	createnewtest: `Skapa nytt test`,
	started: `Påbörjat`,
	starttest: `Starta Test`,
	all: `Alla`,
	users: 'Användare',
	message_noTestsFound: 'Du har inga raderade tester',
	trashcan: 'Papperskorg',
	chooseagroup: `Välj en grupp`,
	distributed: `Distribuerat`,
	notdistributed: `Inte distribuerad`,
	notstarted: `Inte startat`,
	completed: `Genomfört`,
	completeplural: `Genomförda:`,
	seeresults: `Se resultat`,
	status: `Status`,
	testkey: `Testnyckel`,
	type: `Typ`,
	recipient: `Mottagare`,
	actions: `Åtgärder`,
	send: `Skicka`,
	resend: `Skicka igen`,
	save: `Spara`,
	sendcodeemail: `Skicka kod via email`,
	january: `januari`,
	february: `februari`,
	march: `mars`,
	april: `april`,
	may: `maj`,
	june: `juni`,
	juli: `juli`,
	august: `augusti`,
	september: `september`,
	october: `oktober`,
	november: `november`,
	december: `december`,
	norway: `Norge`,
	sweden: `Sverige`,
	germany: `Tyskland`,
	england: `Storbritannien`,
	nederland: `Nederländerna`,
	message_testcannotbedeleted: `Testet måste vara minst 3 månader gammalt för att raderas.`,
	warning_deletetest: `Testet kommer inte längre vara tillgängligt för bedömning. Vill du fortsätta?`,
	headerchildtest: `Testresultat för Dysmate – C (Barntest)`,
	dynamicheaderfortestresult_child: `Detaljerade resultat för Dysmate {0}`,
	dynamicheaderfortestreport_child: `Detaljerad rapport för Dysmate {0}`,
	dynamicheaderfortestcandidate_child: `Detaljerad information för Dysmatekandidat {0}`,
	dynamicheaderfortestresult_adult: `Detaljerade resultat för Dysmate {0}`,
	dynamicheaderfortestreport_adult: `Detaljerad rapport för Dysmate {0}`,
	dynamicheaderfortestcandidate_adult: `Detaljerad information för Dysmatekandidat {0}`,
	headeradulttest: `Resultat för Dysmate A (Screeningtest för vuxna)`,
	showbackground: `Visa kandidats bakgrundsinformation`,
	incompleteMessage: `Testet är inte genomfört. Delprov saknas eller har ej påbörjats.`,
	summary: `Sammanfattning`,
	printtestresults: `Skriv ut resultat`,
	zscorered: `Z-poäng mer än 1 standardavvikelse {0} genomsnittet`,
	zscoregreen: `Z-poäng mer än 1 standardavvikelse {0} genomsnittet`,
	zscoreblue: `Z-poäng ligger inom genomsnittsområdet`,
	overview: `Överblick`,
	assessment: `Bedömningar baserade på resultaten:`,
	textUnderEveryFollowupAssessment:
		'I Dysmate används regressionsbaserade normer för att beräkna testkandidatens resultat. Detta innebär att faktorn årskurs beaktas för att beräkna ett förväntat medelvärde för den grupp som testkandidaten tillhör. I deltesterna Arbetsminne och Spoonerismer ingår även kön som en faktor för att beräkna kandidatens resultat. Testkandidatens råpoäng jämförs med medelvärdet för att beräkna avståndet mellan dessa. Avståndet till medelvärdet beräknas genom att subtrahera medelvärdet från kandidatens råpoäng. Avståndet divideras sedan med standardavvikelsen för gruppen, vilket resulterar i en Z-poäng. Z-poängen visar testkandidatens resultat i förhållande till normgruppen, där medelvärdet är 0 och standardavvikelsen är 1.',
	textUnderEveryScreeningAssessment:
		'I Dysmate används regressionsbaserade normer för att beräkna testkandidatens resultat. Detta innebär att faktorn årskurs beaktas för att beräkna ett förväntat medelvärde för den grupp som testkandidaten tillhör. Testkandidatens råpoäng jämförs med medelvärdet för att beräkna avståndet. Avståndet till medelvärdet beräknas genom att subtrahera medelvärdet från kandidatens råpoäng. Avståndet divideras sedan med standardavvikelsen för gruppen, vilket resulterar i en Z-poäng. Z-poängen visar testkandidatens resultat i förhållande till normgruppen, där medelvärdet är 0 och standardavvikelsen är 1.',
	assessmentspeechok: `{0} har uppnått ett resultat inom normalområdet eller bättre för det experimentella enminutstestet och verkar ha goda läsförmågor.`,
	assessmentspeechnotok: `{0} har uppnått ett resultat under normalområdet för det experimentella enminutstestet och bör genomgå vidare utredning för dyslexi och/eller läsförståelsesvårigheter`,

	asessmenttextok_1: `{0} har uppnått ett resultat inom normalområdet eller bättre för {1} av delproven och verkar ha god läs- och skrivförmåga`,
	asessmenttextnotok_1: `{0} har uppnått ett resultat under normalområdet för {1} av de {2} delproven, och bör genomgå vidare utredning för dyslexi och/eller läsförståelsesvårigheter`,

	assesmenttextok_youthfollowup: `{0} resultat ger inga utslag på de typiskt kognitiva markörerna för dyslexi.`,
	assesmentok_recommendation_youthfollowup: `Om {0} har uppnått resultat under genomsnittsområdet på läsförståelse- och/eller ordförståelsetestet, eller eventuellt på något av de andra deltesten i Dysmate screeningtest, rekommenderar vi en vidare utredning med avseende på möjliga läsförståelsesvårigheter och/eller underliggande språkliga svårigheter såsom utvecklingsrelaterad språkstörning (DLD).`,

	workingmemorylowassesment: `Resultatet ger utslag på Arbetsminne, och {0} erhåller ett resultat som ligger {1} standardavvikelser under genomsnittet för sin årskurs eller ålder på detta test. Arbetsminne är i sig inte en kognitiv markör för dyslexi, men är förknippat med både dyslexi och läsförståelsesvårigheter. Nedsatt arbetsminne kan bland annat påverka hur mycket information man lyckas behålla från en läst text. Det rekommenderas därför att undersöka i vilken utsträckning arbetsminnet påverkar testkandidatens generella inlärningsförmåga och om det finns behov av skolbaserade insatser och anpassningar i detta avseende.`,

	rapidnominationlowassesment: `Resultatet ger utslag vid snabb automatiserad benämning, och {0} erhåller ett resultat som ligger {1} standardavvikelser under genomsnittet för sin årskurs eller ålder vid detta test. Snabb automatiserad benämning mäter hur snabbt och exakt man kan hämta fram ord från språkminnet. Svaga färdigheter inom detta område är en kognitiv markör för dyslexi.`,

	oneminutelowassesment: `Resultatet ger utslag vid 1-minuts ordavkodning och {0} erhåller ett resultat som ligger {1} standardavvikelser under genomsnittet för sin årskurs eller ålder vid detta test. 1-minuts ordavkodning ger ett rent mått på antalet korrekt lästa ord per minut och ger en bra bild av avkodningsförmågan. Svag avkodningsförmåga är en markör för dyslexi.`,

	oneminutelowassesment2: `OBS! Vi rekommenderar att resultatet vid 1-minuts ordavkodning tas i beaktande tillsammans med resultaten från Stavnings- och Ordkedjetestet i Dysmate screeningtest.`,

	spoonerismlowassesment: `Resultatet ger utslag vid Spoonerismer, och {0} erhåller ett resultat som ligger {1} standardavvikelser under genomsnittet för sin årskurs eller ålder på detta test. Spoonerism-testet mäter fonemmedvetenhet och fonologisk bearbetningshastighet. Svaga färdigheter inom dessa områden är en kognitiv markör för dyslexi.`,

	rawscore: `Rå poäng`,
	zscore: `Z-poäng`,
	percentilescore: `Percentilpoäng`,
	tscore: `T-poäng`,
	scaledscore: `Skalpoäng`,
	normalrange: `Normalområde`,
	assessmentsubtestnormal: `Detta resultat ligger inom normalområdet`,
	assessmentsubtestbelow: `Detta resultat ligger {0} standardavvikelser {1} genomsnittet`,
	under: `under`,
	assessmentsubtestabove: `Detta resultat ligger {0} standardavvikelser {1} genomsnittet`,
	over: `över`,
	workingmemorytest: `Arbetsminne`,
	spoonerismtest: `Spoonerism`,
	oneminutetest: `Enminutstest`,
	letterknowledgetest: `Bokstavskunskap`,
	phonemisolationtest: `Fonemisolation`,
	worddictationtest: `Stavning`,
	phonemeomissiontest: `Fonemsubtraktion`,
	wordchaintest: `Ordkedjor`,
	nonwordtest: `Nonsensord`,
	swapsoundtest: `Byt ljud`,
	languageunderstandingtest: `Språkförståelse`,
	typingspeedtest: `Skrivflyt`,
	readingtest: `Läsförståelse`,
	wordcomprehensiontest: `Ordförståelse`,
	loggin: `Logga in`,
	loggout: `Logga ut`,
	trialperiod: `Provperiod`,
	trialuser: `Provanvändare`,
	trialperiodexpired: 'Provperioden har löpt ut',
	trialperiodinprogress: 'Provperiod pågår',
	basicsupcription: `Bas prenumeration`,
	fullsupscription: `Full prenumeration`,
	childsubscription: `Dysmate-C - prenumeration`,
	adultsubscription: `Dysmate-A - prenumeration`,
	youthsubscription: `Dysmate-Y - prenumeration`,
	name: `Namn:`,
	firstname: `Förnamn`,
	lastname: `Efternamn`,
	dateofbirth: `Födelsedatum:`,
	homeLanugage: 'Modersmål',
	birthDate: `Födelsedatum`,
	paneMessageContinueTest: `Detta kommer skicka ut en ny länk till testet så att kandidaterna kan fortsätta ett ofullständig test. Fortsätt?`,
	telephone: `Telefon`,
	email: `E-post`,
	edit: `Redigera`,
	edituser: `Redigera användare`,
	seesubscription: `Se prenumeration`,
	adulttests: `Dysmate-A (Vuxentest)`,
	youthtests: `Dysmate-Y (Ungdomstest)`,
	confirmationofcost: `Prisbekräftelse`,
	sex: `Kön`,
	male: `Man`,
	female: `Kvinna`,
	education: `Utbildning`,
	cancel: `Avbryt`,
	confirm: `Bekräfta`,
	age: `Ålder`,
	age_specified: `Ålder (år)`,
	testdate: `Testdatum`,
	childtest: `Dysmate-C (Barntest)`,
	experimentalchildtest: `Experimentellt barntest`,
	youthtest: `Screeningtest (ungdom, åk 7-9)`,
	adulttest: `Dysmate-A (Screening)`,
	adultscreening: `Dysmate A – (Screeningtest för vuxna)`,
	printedBy: 'Tryckt av:  ',
	youthscreening: `Dysmate-Y – (Screeningtest för ungdomar)`,
	childtests: `Dysmate-C (barntest)`,
	nousedtests: `Ingen använde {0} test`,
	used: `Använda:`,
	boy: `Pojke`,
	girl: `Flicka`,
	logg: `Händelselogg`,
	of: `av {0}`,
	wordsperminute: `ord per minut`,
	deleteoldtests: `Radera gamla test`,
	addtesttogroup: `Lägg till test till en grupp`,
	message_incompletData: `Ogiltig eller ofullständig uppgift`,
	newclasscreated: `Ny klass har skapats`,
	testcandidateremoved: `Testkandidaten har raderats från klasslistan`,
	testcandidateadded: `Testkandidaten har lagts till I klasslistan`,
	classexistchoosename: `Denna klass finns redan, vänligen välj ett annat namn.`,
	class: `.klass`,
	subscription: `Prenumeration`,
	studentID: `Student-ID`,
	supersubscription: `Har prenumeration`,
	mysubscription: `Min prenumeration`,
	seetests: `Se test`,
	currencysymbol: `SEK`,
	hideWithArrow: `Dölj ▲`,
	yourtrialperiodhasexpired: `Din provperiod har tagit slut`,
	upgradeyoursubscription: `Uppgradera din prenumeration`,
	downloadandsendcontract: `För att utfärda fler test måste du ha en prenumeration. Gå till dysmate.se > priser för att teckna abonnemang, eller ladda ner kontraktet och skicka det till `,
	priceandconditioninfo: `. Prisinformation och köpevillkor finns på `,
	downloadcontract: `Ladda ner kontrakt`,
	onlytwotestspertrialperiod: `Endast 2 tester är tillgängliga under provperioden`,
	upgradetofullsubscription: `uppgradera till full prenumeration för att utfärda nya test.`,
	fetch: `Återställ`,
	onlyTrialAccess: `Har endast tillgång till totalt 12 tester`,
	language: `Språk`,
	child: `Barn`,
	youth: `Ungdom`,
	adult: `Vuxen`,
	youthfollowup: `Uppföljningstest (ungdom, åk 7-9)`,
	youthfollowuptest: `Uppföljningstest (ungdom, åk 7-9)`,
	adultfollowup: `Dysmate-A II (Uppföljning vuxen)`,
	adultfollowuptest: `Dysmate-A II (Uppföljningstest vuxen)`,
	childfollowuptest: `Dysmate-C II (Uppföljning barn)`,
	childnorming: `Normering barn`,
	youthnorming: `Normering ungdom`,
	adultnorming: `Normering vuxen`,
	deletedon: `Raderade`,
	basic: `Grundläggande`,
	deletedtests: `Raderade test`,
	viewsubscription: `Se prenumeration ▼`,
	viewdeleted: `Raderade test ▼`,
	referalinformation: `personuppgifter`,
	referalgroups: `gruppmedlemskap`,
	mygroups: `Mina grupper`,
	myinformation: `Mina personuppgifter`,
	message_costsforeachtestthatis_started: `Observera att det, beroende på din prenumeration, kan finnas kostnader för att utfärda nya tester. Tester som inte används kommer inte att debiteras.`,
	test_type: `Testtyp`,
	screeningtest_adult: `Dysmate-A (screeningtest vuxen)`,
	numberoftests: `Antal test (max 30)`,
	create_tests: `Skapa nya test`,
	login: `Logga in`,
	loginwithbankid: `Logga in med följande metoder`,
	message_thisisforcertifieduser: `Detta är för certifierade testadministratörer med prenumeration.`,
	bankid: `BankID`,
	bankidonmobile: `Mobilt BankID`,
	edittestadministrator: `Ändra testadministratör`,
	personalinformation: `Personuppgifter`,
	shcool_or_company: `Skola/företag`,
	addanewtestadministrator: `Lägg till ny testadministratör`,
	addtestadministrator: `Lägg till testadministratör`,
	saveuserinformation: `Spara information om testkandidaten`,
	delete: `Radera`,
	deleteuser: `Radera användare`,
	currentstatus: `Nuvarande status:`,
	savesubscription: `Spara prenumeration`,
	organization: `Organisation`,
	newloginmethod: `Ny inloggningsmetod`,
	errorhasoccured: `Ett fel har inträffat`,
	message_singleuser_perks_trial: `Med en användare kan du få en gratis provperiod på 30 dagar och 2 gratis test av varje typ`,
	message_change_loginmethod: `Du är på väg att ändra din inloggningsmetod. Du kommer fortsätta behöva logga in med denna metod.`,
	info_for_professional_with_either_completed_screening_test: `Detta är för yrkesverksamma som slutfört eller är anmälda till en certifieringskurs och som vill prova några tester innan de tecknar abonnemang.`,
	info_prerequisites_to_obtain_license: `För att få tillgång till provperioden måste du anmäla dig till eller ha slutfört dysmate-certifieringskursen. Alla användare kommer att godkännas manuellt av Dysmate, varefter de kommer att få instruktioner i ett e-postmeddelande för att slutföra sin registrering för att få tillgång.`,
	removefiltering: `Ta bort filter`,
	printreport: `Skriv ut testrapport`,
	testreport: 'Skriv ut testrapport',
	testresult: 'Skriv ut testresultat',
	results: 'Resultat',
	hide: `Dölj`,
	show: `Visa`,
	grade: ' Årskurs',
	userinformation: `Kandidatinformation`,
	localizedwriteuptextforNormalresults:
		'{0} uppnår resultat som ligger  {1} {2} {3} genomsnittet vid {4} av deltesterna. Detta indikerar att {5} har goda läs- och skrivfärdigheter.',
	localizedwriteuptextforOneOtherSubTest:
		'{0} har uppnått ett resultat som ligger {1} {2} {3}. {4} {5}',
	localizedwriteuptextforTwoOtherSubTest:
		'{0} har uppnått ett resultat som ligger {1} {2} {3}. {4} Eftersom {5} uppnår svaga resultat på {6}, {7} och {8} rekommenderas att kandidaten genomför Dysmate uppföljningstest.',
	localizedwriteuptextforThreeORMoreOtherSubTest:
		'{0} har uppnått ett resultat som ligger {1} {2} {3}. {4} Eftersom {5} uppnår svaga resultat på {6}, {7}, {8} {9} {10} {11} rekommenderas att kandidaten genomför Dysmate uppföljningstest.',
	localizedwriteuptextforIncompletedTest:
		'{0} har inte genomfört hela screeningtestet och det saknas därmed underlag för att ge några rekommendationer om ytterligare uppföljning. ',

	localizedwriteuptextforLowScoreOfOrdiktatWithOneOtherSubTest:
		'Stavningssvårigheter kan vara en indikation på dyslexi. {0} resultat på stavningstestet indikerar att ett Dysmate uppföljningstest bör genomföras.',
	localizedwriteuptextforLowScoreOfBetyledeWithOneOtherSubTest: '',
	localizedwriteuptextforLowScoreInLeseprovenAndOrdforstaelse:
		'{0} har uppnått ett resultat som ligger {1} {2} {3}. {4} Eftersom {5} uppnår svaga resultat på ordförståelse- och läsförståelsetestet rekommenderas att testkandidaten genomför Dysmate uppföljningstest. ',
	testreultsforliteratescreeningtest: `Testresultat för Dysmate screeningtest`,
	info_belowpresentsinformation: `Nedanför presenteras testresultaten för {0}, ålder {1} år och {2} månad presenteras nedan.`,
	newinfo_belowpresentsinformation: `Nedanför presenteras testresultaten för {0} Född: {1} {2}`,
	newinfo2_belowpresentsinformation: `Nedanför presenteras testrapport för {0} Född: {1} {2}`,
	newinfo3_belowpresentsinformation: `Nedanför presenteras kandidatinformation för {0} Född {1} {2} {3}`,
	speech1_belowpresentsinformation: `Testresultat för {0}, (Ålder: {1}) presenteras nedan.`,
	printInformation: 'Skriv ut kandidatinformation',
	info_report_belowpresentsinformation:
		'Nedanför presenteras testrapport för {0}{1}{2}',
	info_results_belowpresentsinformation:
		'Nedanför presenteras testresultaten för {0}{1}{2}',
	speech2_belowpresentsinformation: `Testrapport för {0}, (Ålder: {1}) presenteras nedan.`,
	speech3_belowpresentsinformation: `Kandidatinformation för {0}, (Ålder: {1} år) presenteras nedan.`,
	info_testwascompletedon: `Testet slutfördes den {0}`,
	info_testwasNotcompletedon: ` Detta test är ej slutfört.`,
	notetsfound: `Inga slutförda test hittades`,
	background_info_testcandidate: `bakgrundsinformation för testkandidaten`,
	candidate_answers: `Svar från kandidaten`,
	selectLanguage: `Välj språk`,
	norwegian: `Norska`,
	german: `Tyska`,
	dutch: `Nederländska`,
	english: `Engelska`,
	swedish: `Svenska`,
	zscore: `Z-poäng`,
	usersupport: `Användarstöd`,
	groups: `Grupper`,
	groupname: `Gruppnamn`,
	date: `Datum`,
	insert: `Infoga`,
	selected_users: `Välj användare`,
	alreadyexistsingroup: `finns redan I gruppen!`,

	orddiktatheading: `Varje ord presenteras först i en mening för att säkerställa att den korrekta innebörden av ordet som ska stavas förstås. Därefter ombeds kandidaten att skriva målordet som då upprepas. Det finns ingen tidsgräns på detta deltest och både mening och målord kan upprepas en gång.`,
	orddiktatvariabletext: `{0} uppnådde en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger`,

	orddiktatchildheading: `Detta deltest mäter stavningsförmåga samt ortografisk medvetenhet. Testkandidaten ska skriva ord som läses upp högt. Varje ord presenteras först i en mening för att säkerställa att den korrekta innebörden av ordet som ska stavas uppfattas, varefter målordet upprepas. Deltestet har ingen tidsbegränsning. Både meningen och målordet kan vid behov upprepas en gång.`,
	orddiktatchildexplanation: `För varje korrekt svar ges en poäng, och högst 25 poäng kan uppnås.
	Referensvärden (så kallade normer) har tagits fram för varje årskurs i en
representativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits
till både årskurs och kön (pojkar/flickor). För ytterligare information om
normeringen av Dysmate-C, se handboken.
	`,

	orddiktatadultexplanation: `Ett poäng tilldelas för varje korrekt svar (maximalt 45 poäng). Genomsnittspoängen för {0} är {1} och standardavvikelsen är {2} .`,
	orddiktatyouthexplanation: `En poäng ges för varje korrekt stavat ord (max 40 poäng). Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.`,

	fonemisolasjonheading: `Detta test identifierar fonemmedvetenhet hos de yngsta testkandidaterna. I detta test visas fyra bilder för testkandidaten och hen ombeds peka på den bild som antingen börjar eller slutar med ett visst ljud.`,
	fonemisolasjonexplanation: `Ett poäng tilldelas för varje korrekt svar (maximalt 16 poäng). Genomsnittspoängen för {0} är {1} och standardavvikelsen är {2}.`,
	fonemisolasjonvariabletext: `{0} uppnådde en poäng på {1} på detta test. Denna poäng placeras {2} standardavvikelser från detta stegs medelvärde. Detta resultat placeras`,
	fonemutelatelseheading: `Detta test identifierar fonemmedvetenhet hos elever I grundskolan. I detta test presenteras ord verbalt för testkandidaten och denne ombeds att säga det ord som återstår när ett visst ljud tas bort (t.ex. / b / i bröd => röd)`,
	fonemutelatelseexplanation: `Ett poäng tilldelas för varje korrekt svar (maximalt 16 poäng). Genomsnittspoängen för {0} är {1} och standardavvikelsen är {2}.`,
	fonemutelatelsevariabletext: `{0} uppnådde en poäng på {1} på detta test. Denna poäng placeras {2} standardavvikelser från detta stegs medelvärde. Detta resultat placeras`,

	// --- Dysmate-C Follow-up report (SE) ---

	childfollowup_summarypretext: `Denna figur visar {0} individuella resultat i deltesten i Dysmate-C-uppföljningstestet jämfört med normgruppen. De så kallade Z-värdena är angivna (Z-värden är standardiserade värden vars fördelning har ett medelvärde på 0 och en standardavvikelse (SD) på 1).`,

	arbetsminne_childfollowup_heading: `Detta deltest mäter testkandidatens förmåga att kortvarigt lagra, bearbeta och återge verbal information. Testkandidaten får först höra serier med siffror och sedan med ord, vilka testkandidaten ska upprepa i omvänd ordning. Både sifferserien och ordserien ökar i längd om kandidaten klarar den föregående serien. Deltestet avbryts automatiskt efter två felaktiga svar eller icke-svar i följd.`,
	arbetsminne_childfollowup_variabletext: `{0} uppnådde i detta deltest en råpoängssumma om {1}. {3} uppnår alltså ett resultat som ligger `,

	// RAN
	ran_childfollowup_heading: `Detta deltest mäter hur snabbt testkandidaten kan hämta fram namn på bekanta föremål och färger från det språkliga minnet. Testkandidaten uppmanas att snabbt och korrekt namnge föremål i olika färger. Poängen beräknas utifrån antalet korrekta färg- och föremålskombinationer dividerat med den totala tid det tar att namnge alla 50 färg- och föremålskombinationerna. Även detta test är tidsbestämt.`,
	ran_childfollowup_variabletext: `{0} uppnådde i detta deltest en råpoängssumma om {1}. {3} uppnår alltså ett resultat som ligger `,

	// 1-minut
	oneminute_childfollowup_heading: `Detta är ett högläsningstest som bedömer avkodningsförmåga på ordnivå. Testkandidaten får en lista med ord och ombeds att läsa så snabbt och korrekt som möjligt inom en tidsram på 60 sekunder. Resultatet ger ett mått på antalet korrekt lästa ord per minut.`,
	oneminute_childfollowup_variabletext: `{0} uppnådde i detta deltest en råpoängssumma om {1}. {3} uppnår alltså ett resultat som ligger `,

	fonemsubtraktion_childfollowup_heading: `Detta test mäter fonemisk medvetenhet och hur väl testkandidaten kan uppmärksamma och arbeta med språkljud. 
	Testkandidaten får höra ett ord och ska säga vad som blir kvar när man tar bort ett bestämt ljud i ordet (t.ex. /g/ i «gris» → «ris»).\n\nFör varje rätt svar erhålls en poäng (maximalt 16 poäng).`,
	fonemsubtraktion_childfollowup_variabletext: `{0} uppnådde i detta deltest en råpoängssumma om {1}. {3} uppnår alltså ett resultat som ligger `,

	ettminuttstestheading: `Detta är ett högläsningstest som bedömer ordavkodningsförmåga. Kandidaten får en lista med ord och ombeds att läsa så snabbt och korrekt som möjligt inom en tidsram på 60 sekunder. Resultatet ger ett mått på antalet korrekt lästa ord per minut.`,
	ettminuttstestexplanation: `En poäng ges för varje korrekt läst ord. Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.`,
	ettminuttstestvariabletext: `{0} uppnår en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger `,

	hurtigbenevningheading: `Detta test bedömer hur snabbt kandidaten kan namnge bekanta föremål och hämta fram namn på föremål och färger från det språkliga långtidsminnet.`,
	hurtigbenevningexplanation: `En poäng ges för varje korrekt kombination av färg och föremål som kandidaten namnger. Testet är också tidsbestämt. Poängen beräknas utifrån antalet korrekta färg- och föremålskombinationer dividerat med den totala tiden det tar att nämna alla 50 färg- och föremålskombinationer. Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}. `,
	hurtigbenevningvariabletext: `{0} uppnår en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger `,

	arbeidsminnenummberheading: `Detta test mäter kandidatens förmåga att lagra och bearbeta information samtidigt som man löser en uppgift. Testkandidaten presenteras först för en serie med siffror och sedan en serie med ord. Dessa ska sedan upprepas i omvänd ordning från hur de presenterades. Både sifferserien och ordserien ökar i längd.`,
	arbeidsminneexplanation: `För varje rätt svar ges en poäng (max 12 poäng för sifferserien och max 12 poäng för ordserien, totalt max 24 poäng). Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}. `,
	arbeidsminnevariabletext: `{0} uppnår en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger `,
	arbeidsminneheading: `Detta test identifierar testkandidatens förmåga att lagra och bearbeta information. I detta test presenteras för testkandidaten en serie siffror, sedan en serie ord, vilka ska upprepas i motsatt ordning. Både sifferraderna och ordraderna ökar I längd om testkandidaten klarar den föregående raden.`,

	arbetsminne_childfollowup_explanation: `För varje rätt svar erhålls en poäng (maximalt 12 poäng för sifferserien och 12 poäng för ordserien, totalt 24 poäng). Förväntat resultat för kandidaten är {0}.`,

	ran_childfollowup_explanation: `En poäng ges för varje korrekt kombination av färg och föremål som testkandidaten namnger. Förväntat resultat för kandidaten är {0}.`,

	oneminute_childfollowup_explanation: `En poäng ges för varje korrekt läst ord. Förväntat resultat för kandidaten är {0}. Resultatet tolkas i relation till referensvärden för testkandidatens årskurs.`,

	fonemsubtraktion_childfollowup_explanation: `För varje korrekt svar erhålls en poäng. Förväntat resultat för kandidaten är {0}.`,

	ordforståelseheading: `Testet mäter ordförståelse genom att testkandidaten ombeds hitta ett ord som har samma betydelse som ett givet målord. I varje uppgift får testkandidaten välja mellan fyra alternativ. Detta test ger ett mått på ordförrådets bredd och djup.`,
	ordforståelseexplanation: `Ett poäng tillskrivs för varje korrekt svar (maximalt 15 poäng). Genomsnittspoängen för {0} är {1} och standardavvikelsen är {2}.`,
	ordforståelsevariabletext: `{0} uppnådde en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger `,
	ordforståelseyouthexplanation: `För varje rätt svar erhålls en poäng (max 20 poäng). Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.`,

	spoonerismheading: `Detta test mäter fonemmedvetenhet och fonologisk bearbetningshastighet. Testkandidaten får 25 ordpar presenterade för sig muntligt och ombeds sedan att byta plats på de första ljuden i de två orden så snabbt och korrekt som möjligt.`,
	spoonerismexplanation: `En poäng ges för varje korrekt ord som kandidaten lyckas säga med det nya första ljudet (max 50 poäng). Testet är också tidsbestämt. Poängen beräknas utifrån antalet korrekta ord som har ändrat sitt första ljud, dividerat med den tid det tar att slutföra uppgifterna. Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.  `,
	spoonerismvariabletext: `{0} uppnår en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger `,

	leseprøvenheading: `Detta test är ett tyst läsprov som mäter läsförståelse genom att testkandidaten måste svara på frågor direkt från texten, sammanställa information från olika avsnitt och dra slutsatser. Testkandidaten har 10 minuter på sig att läsa texten och svara på så många flervalsfrågor som möjligt. N.B. Här är det viktigt att registrera om testkandidaten har svarat fel eller lämnat flervalsfrågorna obesvarade (på grund av lågläshastighet).`,
	leseprøvenyouthheading: `Detta test är ett tyst lästest som mäter läsförståelse genom att testkandidaten får svara på frågor, sammanfatta information från olika avsnitt och dra slutsatser utifrån en text. Testkandidaten får 12 minuter på sig att läsa texten och svara på så många flervalsfrågor som möjligt. OBS! Här är det viktigt att läraren noterar, vid sidan av, om testkandidaten beskriver att den har svarat fel på frågorna eller inte besvarat dem (på grund av en lägre läshastighet som gjort att kandidaten inte hunnit besvara frågorna).`,
	leseprøvenexplanation: `Ett poäng tilldelas för varje korrekt svar (maximalt 14 poäng). Genomsnittspoängen för {0} är {1} och standardavvikelsen är {2}`,
	leseprøvenyouthexplanation: `För varje rätt svar erhålls en poäng (max 14 poäng). Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.`,
	leseprøvenvariabletext: `{0} uppnådde en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger `,

	skrivehastighetheading: `Detta test mäter skrivflyt, alltså hur effektivt en person kan skriva. Detta är en förmåga som är viktig, exempelvis när man antecknar eller skriver ett prov. Kandidaten ser hela tiden en mening framför sig och ska skriva av den så många gånger och så korrekt som möjligt inom 2 minuter.`,
	skrivehastighetexplanation: `Poängen baseras på antalet korrekt skrivna ord i genomsnitt per minut. Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.`,
	skrivehastighetvariabletext: `{0} uppnådde en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger `,

	tulleordtestenheading: `Detta test är ett tyst lästest som mäter fonologisk medvetenhet och fonologisk bearbetningshastighet. Detta anses vara en språkligt-kognitiv markör för dyslexi. Testkandidaten måste hitta det nonsensord som låter som ett riktigt ord. Vid varje uppgift måste testkandidaten välja mellan fem alternativ, varav endast ett är korrekt. Testkandidaten har två minuter på sig att lösa så många uppgifter som möjligt.`,
	tulleordtestenexplanation: `För varje rätt svar erhålls en poäng (max 30 poäng). Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.`,
	tulleordtestenvariabletext: `{0} uppnådde en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger `,

	ordkjedetestenheading: `Detta är ett tyst lästest som mäter snabb ordigenkänning och ortografisk kunskap. Här ombeds testkandidaten att skapa ett mellanrum mellan ord som är ihopskriva i en kedja. Varje kedja består av fyra slumpmässiga ord. Testkandidaten får 4 minuter på sig att lösa så många ordkedjor som möjligt.`,
	ordkjedetestenexplanation: `Ett poäng tilldelas för varje korrekt svar (maximalt 40 poäng). Genomsnittspoängen för {0} är {1} och standardavvikelsen är {2}.`,
	ordkjedetestenvariabletext: `{0} uppnådde en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger `,
	ordkjedetestenyouthexplanation: `En poäng ges för varje korrekt svar (max 50 poäng). Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.`,

	fonemsubtraktionlowassesment: `Resultatet ger utslag på deltestet Fonemsubtraktion (Ta bort ljud) och {0} resultat ligger {1} standardavvikelser under genomsnittet för sin årskurs. Deltestet mäter fonemisk medvetenhet och fonologisk bearbetningshastighet. En svaghet inom detta område är en kognitiv markör för dyslexi.`,
	textUnderEveryChildFollowupAssessment:
		'I Dysmate används regressionsbaserade normer för att bedöma resultaten. Det innebär att faktorer som kön och årskurs tas i beaktande för att sätta det individuella testresultatet (beräknat från råpoängen i respektive deltest) i relation till en jämförelsegrupp.',
	chooseagroup: `Välj en grupp`,
	averageForGrade: 'medelvärdet för årskursen.',
	includeLongIntro: `Inkludera självbedömning / anamnese`,
	anamneseexplaination: `Om testet enbart används för screening är det inte nödvändigt att inkludera självbedömning / anamnese`,
	chooselanguage: `Välj språk`,
	seegrouptests: `Se tester i grupper`,
	addtogroup: `Lägg till i gruppen`,
	nogroupsfound: `Inga grupper funna`,
	fromgroups: `Från grupp`,
	allmytests: `Alla mina tester`,
	mytests: `Mina tester`,
	groupindicator: `-----Grupper-----`,
	notanswered: `ej besvarad`,
	testnotanswered: `{0} frågor ej besvarade`,
	showunanswered: `Visa obesvarade`,
	hideunanswered: `Dölj obesvarade`,
	rightanswer: `Korrekt besvarade: {0}`,
	action: `Åtgärd`,
	deleteall: `Radera alla`,
	chooseclass: `Välj klass`,
	confirmationdeleteclass: `Är du säker på att du vill radera detta {0}`,
	theclass: `Klass`,
	multipleclasses: `klasser`,
	myclasses: `Mina klasser`,
	deleteclass: `Radera klass`,
	message_noclasses: `Du har inte skapat några klasser`,
	showtests: `Visa tester ▼`,
	allmycandidates: `Alla mina kandidater`,
	notestsforcandidate: `Denna kandidat har inte slutfört några tester`,
	gender: `Kön`,
	nocandidates: `Du har inga kandidater`,
	choosecandidate: `Välj en kandidat`,
	classindicator: `-----Klasser-----`,
	sendtest: `Skicka test`,
	createclass: `Skapa Klass`,
	removefromclass: `Ta bort från klassen`,
	providevalidname: `Ange ett giltigt namn`,
	searchhere: `Sök här...`,
	searchByTestKey: 'Sök Test nyckel',
	createNotification: 'Opprett et varsling',
	viewNotification: 'Se varslinger',
	postNotification: 'Post Notification',
	areyousure: 'Är du säker?',
	editNotification: 'Rediger Varsling',
	notificationcreated: 'Varning skapad',
	allnotifications: 'Alla aviseringar',
	nonotificationsfound: 'Inga varningar hittades',
	createnotificationwarning:
		'Du kan inte ändra meddelandet när det väl har lagts upp',
	newclass: `Ny Klass`,
	writeclassname: `Ge klassen ett namn…`,
	deleting: `Raderar`,
	mypage: `Min sida`,
	theagegroup: `åldersgrupp`,
	hiddenname: `<Dolt namn>`,
	wordreadcorrectly: `Korrekt lästa ord`,
	correct: `Korrekt`,
	fulltAbonnemang: 'Aktiv Prenumeration',
	wrong: `Fel`,
	followuptests: `Uppföljningstester`,
	timeused: `Tid använd`,
	thisagegroup: `åldersgrupp`,
	adminpersonalinformation: `Personuppgifter`,
	readingTest_questioncount: 14,
	password: `Lösenord`,
	confirmpassword: `Bekräfta lösenord`,

	assessmentscreening: `Gesamtbewertung auf der Grundlage der Ergebnisse 
	aller Subtests aus dem Screening:`,
	assessmentfollowup: `Gesamtbewertungen auf der Grundlage der Ergebnisse 
	aller Subtests aus dem Follow-up`,
	summarypretext: `Denna figur visar {0} individuella resultat i screeningdeltesten jämfört med normurvalet. De så kallade Z-värdena (standardiserade värden; medelvärde 0, standardavvikelse 1) visas
	`,
	inforeferall: `För elevens specifika profil hittar du resultaten från screeningens individuella delprov nedan. För en övergripande illustration av kategoriseringen av testvärden kan du också ta en titt på grafiken.
	`,
	infor_scr_ageAtCommencement:
		' Ålder vid testgenoförandet var {0} år och {1} månader.',
	classGrade: 'Årskurs',
	bulkSending: 'Massutskick',
	createanddistributetests:
		'Om du vill skick många tester på samma gång kan du klistra in e-postadresser i fältet här och trycka på "Skapa och skicka".',
	pasteEmails: 'Klistra in e-post, en e-post per linje',
	remembertoprovideemail:
		'Märk att e-postadresserna måste avskiljas med ett komma-tecken, exempelvis:',
	createAndSend: 'Skapa och skicka',
	somthingWentWrong: 'Hoppsan! Något gick fel.',
	testDistributedSuccessfully: 'Testerna har nu skickats iväg!',
	handbooktitle:
		'{0} På denna sida hittar du användbara resurser för att använda Dysmate.',
	screeningTest: 'Screeningtest',
	followUpTest: 'Uppföljningstest',
	fillSelfCandidateInfo: 'Testledare fyller i kandidatens uppgifter',
	fillKandidateInformation1: `
	Testledaren fyller i testkandidatens uppgifter innan denne loggar in för att göra testet. Detta rekommenderas för de yngre årskurserna. Kandidaten kommer då snabbt igång med testet och kan logga in med pinkod.`,
	letCandidateFillInfo: `Låt kandidaten fylla i uppgifterna själv`,
	fillKandidateInformationSelf1: `Detta gör det möjligt att skicka ut testet direkt via e-post till kandidaten. Kandidaten behöver då logga in och fylla i sina uppgifter (namn, kön, födelsedatum och årskurs).`,

	fillKandidateInformationSelf2: `Detta passa vanligtvis för äldre elever i mellanstadiet som har tillgång till egen e-post adress.`,
	candidateInfoCommon: `Testkandidaten går till www.dysmate.se → "TA TESTEN".`,
	candidateInfoReminder:
		'Observera att pinkoden också är tillgänglig på testledarsidan under <<Mina tester>>.',

	bytaljud_childscrng_heading: `Detta test mäter fonologisk medvetenhet och fonologisk bearbetningshastighet, vilka är språkliga och kognitiva markörer för dyslexi. Uppgiften består i att testkandidaten ska byta ut ett visst enskilt ljud i ett ord mot ett annat och därmed bilda ett nytt ord. Ett exempel är att byta ut ljudet /b/ i ordet «bil» med ljudet /p/. I varje uppgift visas en illustration av målordet (t.ex. bil) följt av fyra illustrerade svarsalternativ. Endast ett av alternativen är korrekt (här: «pil»), de övriga illustrationerna fungerar som distraktorer. Testkandidaten har 10 sekunder på sig att lösa varje uppgift. En ny uppgift startar automatiskt på skärmen om kandidaten inte har svarat inom tidsgränsen. Vid fem på varandra följande felaktiga svar avslutas testet.`,

	bytaljud_childscrng_variabletext: `{0} har i detta deltest uppnått en råpoängsumma om {1}, vilket motsvarar en prestation som ligger`,

	ordkedjor_childscrng_heading: `Detta deltest syftar till att mäta tyst läsförmåga och hastigheten i ordigenkänning och ortografisk kunskap. Här ombeds testkandidaten att skapa ett mellanrum mellan ord som är ihopskriva i en kedja. Varje kedja består av fyra slumpmässiga ord. Testkandidaten får 4 minuter på sig att lösa så många ordkedjor som möjligt.`,

	ordkedjor_childscrng_variabletext: `{0} har i detta deltest uppnått en råpoängsumma om {1}, vilket motsvarar en prestation som ligger`,

	skrivflyt_childscrng_heading: `Detta deltest mäter skrivhastighet och skrivflyt, alltså effektiviteten i skrivförmågan på meningsnivå. Detta är en förmåga som är viktig, exempelvis när man antecknar eller skriver ett prov. Testkandidaten ser hela tiden en mening framför sig på sin skärm och ska skriva av den så många gånger och så korrekt som möjligt inom 2 minuter.`,

	skrivflyt_childscrng_variabletext: `{0} har i detta deltest uppnått {1} ord per minut, vilket motsvarar en prestation som ligger`,

	lasforstaelse_childscrng_heading: `Detta deltest är en tyst läsuppgift som mäter läsförståelse genom att testkandidaten ska besvara frågor utifrån texten, vilket kräver att kandidaten kan sammanfatta information från olika avsnitt och dra slutsatser utifrån en text. Testkandidaten får 10 minuter på sig att läsa texten och svara på så många flervalsfrågor som möjligt. OBS! Här är det viktigt att skilja på och notera om testkandidaten har svarat fel på flervalsfrågorna eller inte hunnit besvara frågorna (på grund av en lägre läshastighet).`,

	lasforstaelse_childscrng_variabletext: `{0} har i detta deltest uppnått en råpoängsumma om {1}, vilket motsvarar en prestation som ligger`,

	ordforstaelse_childscrng_heading: `Detta deltest mäter receptivt ordförråd och semantisk kunskap. Testkandidaten ombeds hitta ett ord från en utvalslista som har samma betydelse som ett givet målord. I varje uppgift får testkandidaten välja mellan fyra alternativ.`,

	ordforstaelse_childscrng_variabletext: `{0} har i detta deltest uppnått en råpoängsumma om {1}, vilket motsvarar en prestation som ligger`,

	stavning_childscrng_variabletext: `{0} har i detta deltest uppnått en råpoängsumma om {1}, vilket motsvarar en prestation som ligger`,

	childscrng_norms_intro: `Jämförelsevärden (så kallade normer) har samlats in för varje årskurs i en representativ grupp av elever över hela landet. Här beaktades förutom årskurs även kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.`,

	childscrng_text1: `{0} har uppnått ett resultat som ligger {1}.\n\n{2}\n\nEftersom {3} erhöll svaga resultat på {4} rekommenderas att testkandidaten genomför Dysmate-uppföljningstest. För ytterligare fördjupning i resultaten rekommenderas att man läser {5}.`,
	childscrng_text2: `{0} har uppnått resultat som ligger {1}. {2}

Eftersom {3} erhöll svaga resultat på {4} rekommenderas att testkandidaten genomför Dysmate-uppföljningstest. Om {6} även erhåller svaga resultat gällande Arbetsminne och Snabb automatiserad benämning/RAN i uppföljningstestet rekommenderas en utökad bedömning av testkandidatens språkförståelse. För ytterligare fördjupning i resultaten rekommenderas att man läser {5}.`,
	childscrng_text3: `{0} har uppnått ett resultat som ligger {1}.\n\n{2}\n\nResultatet på Fonembyte-testet indikerar att det bör göras en närmare bedömning av {3} fonemiska medvetenhet och fonologiska bearbetningshastighet. Det rekommenderas därför att Dysmate-C uppföljningstestet genomförs. För ytterligare fördjupning i resultaten rekommenderas att man läser {4}, Kapitel 6:\nRiktlinjer för tolkning.`,
	childscrng_text4: `{0} uppnår resultat som ligger inom och/eller klart över genomsnittsområdet på {1} av deltesterna. Resultaten från screeningtestet ger inte någon indikation på behov av uppföljningstest med Dysmate.`,

	childscrng_text5: `{0} har inte slutfört hela screeningtestet, och det finns därför ingen grund för att ge några rekommendationer om ytterligare uppföljning.`,
	classOverview: 'Klassöversikt',
	testCandidate: 'Testkandidat',
	resultsReport: 'Resultatrapport',
	rapidautonamingtest: 'Snabb automatiserad benämning',
	spoonerism: `Spoonerismer`,
	oneminute: `1-minuts ordavkodning`,
	redAverageArea: `Röd: Z-poäng under genomsnittsområdet`,
	yellowAverageArea: `Gul: Z-poäng inom genomsnittsområdet`,
	greenAverageArea: `Grön: Z-poäng över genomsnittsområdet`,
	candidateFirstName: 'Förnamn',
	candidateLastName: 'Efternamn',
	candidateEmail: 'E-post (valbart*)',
	candidateGender: 'Kön',
	candidateBirthDate: 'Födelsedatum',
	candidateBirthFormat: 'ÅÅÅÅ-MM-DD',
	candidateGrade: 'Årskurs',
	gradeDropDown: '-Välj årskurs-',
	gotoDysmtateSite: 'Gå till www.dysmate.se',
	testCommenceInstructions1: 'Väljer ”TA TESTEN” högst upp på sidan',
	testCommenceInstructions2: 'Välj sedan Dysmate-C screeningtest',
	testCommenceInstructions3: 'Skriv in testnyckeln',
	testCommenceInstructions4: 'Logga in med pinkod',
	testCommenceInstructions5:
		'E-post är valfritt. Om fältet lämnas tomt behöver du dom testledare ge pinkoden till testkandidaten så denne kan logga in.',
	testCommenceInstructions6:
		'Om du skriver in en e-postadress så skickas både testnyckel och pinkod till testkandidatens mejl.',
	question_excludeReadingTest:
		'Vill du utesluta deltestet läsförståelse? Detta kan göras för barn som ännu inte har lärt sig läsa.',
	fillOutInfo: 'Fyll i information',

	stavning_childscrng_explanation: `För varje korrekt svar ges en poäng, och högst 25 poäng kan uppnås. Förväntat resultat för kandidaten är {0}.\n\nReferensvärden (så kallade normer) har tagits fram för varje årskurs i en representativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits till både årskurs och kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.`,

	ordkedjor_childscrng_explanation: `För varje korrekt svar (korrekt uppdelat ord) ges en poäng. Förväntat resultat för kandidaten är {0}.\n\nReferensvärden (så kallade normer) har tagits fram för varje årskurs i en representativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits till både årskurs och kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.`,

	bytaljud_childscrng_explanation: `För varje korrekt svar ges en poäng, och högst 21 poäng kan uppnås. Förväntat resultat för kandidaten är {0}.\n\nReferensvärden (så kallade normer) har tagits fram för varje årskurs i en representativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits till både årskurs och kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.`,

	skrivflyt_childscrng_explanation: `Poängen baseras på antalet korrekt skrivna ord per minut. Förväntat resultat för kandidaten är {0}.\n\nReferensvärden (så kallade normer) har tagits fram för varje årskurs i en representativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits till både årskurs och kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.`,

	lasforstaelse_childscrng_explanation: `För varje korrekt svar ges en poäng, och högst 8 poäng kan uppnås. Förväntat resultat för kandidaten är {0}.\n\nReferensvärden (så kallade normer) har tagits fram för varje årskurs i en representativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits till både årskurs och kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.`,

	ordforstaelse_childscrng_explanation: `För varje korrekt svar ges en poäng, och högst 18 poäng kan uppnås. Förväntat resultat för kandidaten är {0}.\n\nReferensvärden (så kallade normer) har tagits fram för varje årskurs i en representativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits till både årskurs och kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.`,
	showearliermonths: 'Se tidigare månader ▼',
	notavailable: 'Inte tillgänglig',
	selectedTestRemovedFromGroup: 'Valda {0} har tagits bort från grupper',
	nei: 'Nej',
	leggTil: 'Lägg till',
	rapport: 'Rapport',
	kommentarer: 'Kommentarer',
	// Error / status messages
	kunneIkkeLoggeInn: 'Kunde inte logga in!',
	gruppenEksistererAllerede: 'Gruppen finns redan',
	ikkebrukt: 'Inte använd',
	oppgaverIkkeBesvart: 'uppgifter inte besvarade',
	// Login methods
	loggInnMedBankID: 'Logga in med BankID',
	loggInnMedFeide: 'Logga in med Feide',
	// Print
	skrivUtMedAnteckningar: 'Skriv ut med anteckningar',
	lageOpplysninger: 'Lägg till information',
	// Group/class membership messages
	kandidaterLagtTilIGruppen: ' kandidater tillagda i gruppen',
	detErIkkeTillat:
		'Det är inte tillåtet att ändra något för det valda alternativet',
	removingFromGroupInfo:
		'Om testet är delat i en grupp, kommer detta att ta bort testet från gruppen det lades till i.',
	removefromgroup: 'Ta bort från grupper',
	classAddedToGroup: 'Klassen är nu tillagd i gruppen',
	testDeleted: 'Testet har raderats',
	nogroupcreateone: 'Du har inga grupper. Skapa en grupp först.',
	classingroupalready:
		'Den valda klassen ligger redan i alla tillgängliga grupper.',
};
